module.exports = __webpack_public_path__ + "img/sld_mccb_horizontal.64dc86b7.svg";